import React from "react";
import { FaEnvelopeOpenText, FaPaperPlane } from "react-icons/fa";

import { MESSAGE_TABS } from "../utils/messagerieUtils";

function EmptyMessages({ activeTab, onCompose }) {
  const isReceived = activeTab === MESSAGE_TABS.received;

  return (
    <div className="rounded-[2rem] border border-slate-200 bg-white p-6 text-center shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-white/[0.05] dark:shadow-black/20">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-3xl bg-sky-100 text-sky-700 dark:bg-sky-500/10 dark:text-sky-200">
        {isReceived ? (
          <FaEnvelopeOpenText className="text-2xl" />
        ) : (
          <FaPaperPlane className="text-2xl" />
        )}
      </div>

      <h2 className="mt-5 font-titre text-2xl font-bold text-slate-950 dark:text-white">
        {isReceived ? "Aucun message reçu" : "Aucun message envoyé"}
      </h2>

      <p className="mx-auto mt-3 max-w-xl text-sm font-medium leading-7 text-slate-600 dark:text-white/55">
        {isReceived
          ? "Votre boîte de réception est vide pour le moment."
          : "Vous n’avez pas encore envoyé de message depuis cette messagerie."}
      </p>

      <button
        type="button"
        onClick={onCompose}
        className="mt-6 inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-blue-600 to-orange-500 px-5 py-3 text-sm font-bold text-white shadow-lg shadow-orange-500/20 transition hover:-translate-y-0.5"
      >
        <FaPaperPlane />
        Écrire un message
      </button>
    </div>
  );
}

export default EmptyMessages;